import styles from "css/Calendar.module.css"
import { useState, useEffect, useRef } from "react"
import { Box, SelectList } from "components"
import useApp from "hooks/useApp"
import Lib from "library"
import { Link } from "react-router-dom"

const Calendar = ({ date }) => {
	//#region Variables
	const App = useApp()
	const currentDate = useRef(date)
	const [firstDate, setFirstDate] = useState()
	const [searchShow, setSearchShow] = useState(false)
	const [searched, setSearched] = useState()
	const [searchText, setSearchText] = useState()
	const [tasks, setTasks] = useState()
	const [calendar, setCalendar] = useState()
	const [today, setToday] = useState()
	const [selectData, setSelectData] = useState()
	const [fold, setFold] = useState(true)

	const grid = useRef()
	//#endregion

	//#region Mehods
	const onSearchSelect = (key, value) => {
		currentDate.current.setYear(value.getFullYear())
		currentDate.current.setMonth(value.getMonth())
		setSearched(value)
		setFold(false)
		console.log("set")
	}

	const getSelectData = () => {
		const data = []
		let y = currentDate.current.getFullYear()
		let m = currentDate.current.getMonth() + 1
		for (let i = 12; i > 0; i--) {
			const d = new Date(y, m - 1)
			if (i === 12) setSearched(d)
			const item = {
				key: `${y}년 ${m}월`,
				value: d,
			}
			data.push(item)
			m--
			if (m < 1) {
				y--
				m = 12
			}
		}
		setSelectData(data)
	}

	const getCalendar = () => {
		resetSelectedCell()
		const firstDay = new Date(currentDate.current.getFullYear(), currentDate.current.getMonth(), 1).getDay()
		const lastDate = new Date(currentDate.current.getFullYear(), currentDate.current.getMonth() + 1, 0).getDate()
		const cal = []
		let over = false
		let date = 1
		for (let i = 0; date <= lastDate; i++) {
			const day = i % 7
			if (firstDay === day) over = true
			cal.push({
				day: day,
				date: over ? date : null,
			})
			if (over) date++
		}
		setCalendar(cal)
	}

	const foldHandler = () => {
		if (fold) {
			setGridHeight()
		} else {
			grid.current.removeAttribute("style")
		}
		setFold((fold) => !fold)
	}

	// 캘린더 조회
	const getTasks = () => {
		let m = Number(currentDate.current.getMonth()) + 1
		if (m < 10) m = "0" + m

		Lib.get(`/api/finc/clndr`, {
			ym: `${currentDate.current.getFullYear()}${m}`,
		},
			data => {
				setTasks(data)
			}
		)
	}

	const setGridHeight = () => {
		const h = Math.ceil(grid.current.childElementCount / 7)
		grid.current.style.height = `${h * 6 + 2}rem`
	}

	const checkTask = (date) => {
		if (!tasks) return <></>
		const found = tasks.find((task) => {
			const d = new Date(task.payDate.substr(0, 4), Number(task.payDate.substr(4, 2)) - 1, task.payDate.substr(6, 2))
			return currentDate.current.getFullYear() === d.getFullYear() && currentDate.current.getMonth() === d.getMonth() && date === d.getDate()
		})
		if (found) {
			return <span className={`${styles.amount} number`}>{Lib.addComma(found.payExpAmt)}</span>
		}
	}

	const resetSelectedCell = () => {
		const ons = document.querySelectorAll(`.${styles.on}`)
		ons.forEach((element) => {
			element.classList.remove(styles.on)
		})
	}

	const onCellClick = (e, date) => {
		resetSelectedCell()
		const target = e.currentTarget || e.target
		target.classList.add(styles.on)

		const d = target.querySelector("span").innerHTML
		currentDate.current.setDate(d)

		const y = currentDate.current.getFullYear()
		const m = currentDate.current.getMonth() + 1
		const todayDate = `${y}${Lib.leadingZero(m)}${Lib.leadingZero(date)}`

		Lib.get(`/api/finc/clndr/pay/acnt/${todayDate}`, {
			asset: "A",
			cnsmp: "A",
			loan: "A",
			todayDate: todayDate,
		})
	}

	const scrollToToday = () => {
		if (!grid.current) return
		const today = grid.current.querySelector(`.${styles.today}`)
		if (today) {
			const y = today.getBoundingClientRect().y
			const gy = grid.current.getBoundingClientRect().y
			// grid.current.scrollTop = y - gy
			Lib.scrollTo(grid.current, y - gy)
		}
	}
	//#endregion

	//#region Effects
	useEffect(() => {
		if (!fold) setGridHeight()
	}, [calendar])

	useEffect(() => {
		getCalendar()
	}, [tasks])

	useEffect(() => {
		setToday(new Date())

		getSelectData()

		getTasks()

		if (!grid.current.hasAttribute("data-binded")) {
			grid.current.addEventListener(Lib.getTransitionEndType(), (e) => {
				grid.current.setAttribute("data-binded", true)
				if (grid.current.classList.contains(styles.fold)) {
					scrollToToday()
				}
			})
		}

		setTimeout(scrollToToday, 1000)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	//#endregion

	return (
		<div className={`${styles.Calendar} pt_20`}>
			<Link to='/calendar/expend'>
				<Box className={styles.guide}>이번달은 또 얼마나 썼을까?</Box>
			</Link>
			<div className={`${styles.title} mt_30`} onClick={() => setSearchShow(true)}>
				<span className='number'>{currentDate.current.getMonth() + 1}</span>
				<span>월</span>
				<i className='icon_arrow_down ml_10' />
			</div>
			<div className={`${styles.pannel} mt_35`}>
				<div className={styles.headers}>
					<div>일</div>
					<div>월</div>
					<div>화</div>
					<div>수</div>
					<div>목</div>
					<div>금</div>
					<div>토</div>
				</div>
				<div ref={grid} className={`${styles.grid}${fold ? ` ${styles.fold}` : ``}`}>
					{calendar &&
						calendar.map((item, index) => {
							if (currentDate.current.getMonth() === today.getMonth() && today.getDate() === item.date) {
								// return <div className={styles.today} key={item.date}>{index}<span className={`${styles.amount} number`}>11,000,000</span></div>
								return (
									<div className={`${styles.today}`} key={index} onClick={(e) => onCellClick(e, item.date)}>
										<span className={styles.num}>{item.date}</span>
										{checkTask(item.date)}
									</div>
								)
							} else {
								return (
									<div key={index} onClick={(e) => onCellClick(e, item.date)}>
										<span className={styles.num}>{item.date}</span>
										{checkTask(item.date)}
									</div>
								)
							}
						})}
				</div>
				<div className={`${styles.more} mt_20`} onClick={foldHandler}>
					{fold ? "더보기" : "접기"}
					<i className={`icon_arrow_up ml_10 ${fold ? styles.reverse : ""}`} />
				</div>
				{/* 더보기/접기버튼 */}
			</div>
			<SelectList data={selectData} show={searchShow} selected={searched} onSelect={onSearchSelect} setShow={setSearchShow} setText={setSearchText} title='월선택' />
		</div>
	)
}

export default Calendar
